//TODO: AUTHOR
export default {
  title: "न्यूज तक",
  canonical_url: "/author/takcms",
  image:
    "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/default-author-image.png",
};
